import React from "react";
import Navbar from "../Navbar/Navbar";
import TopBar from "../TopBar/TopBar";
import Footer from "../Footer/Footer";
import { Link, useLocation, useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import parse from 'html-react-parser'

import { BsWhatsapp } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import { FaFacebookF } from "react-icons/fa"; 
import { FiLink } from "react-icons/fi"; 
import { api_url, media_url } from "../../url";
import axios from "axios";
import Loading from "../Loading/Loading";
import { toast } from "react-toastify";

const NewsItem = () => {
  const { slug } = useParams();
  const [gettingNews, setGettingNews] = useState(true)
  const [news, setNews] = useState([])
  const [loading, setLoading] = useState(false)
  const [mainNews, setMainNews] = useState({});
  const [selectedImage, setSelectedImage] = useState(null); // Lightbox state

  const getNewsItem = async (news_slug) => {
    setLoading(true)
    const config = {
      header:{
        'Content-Type': 'application/json'
      }
    }
    await axios.get(`${api_url}website/news/${news_slug}/`, config).then((response)=>{
      setMainNews(response.data)
      setLoading(false)
    }).catch((error)=>{
      console.error(error)
      setLoading(false)
    })
  }
  
  const getNews = async () => {
    const config = {
      header:{
        'Content-Type': 'application/json'
      }
    }
    await axios.get(`${api_url}website/news/?paginated=false`, config).then((response)=>{
      setNews(response.data)
      setMainNews(response.data?.find((newsItem) => newsItem.slug === slug));
      setGettingNews(false);
    }).catch((error)=>{
      console.error(error)
      setGettingNews(false)
    })
  }

  useEffect(() => {
    getNews()
    getNewsItem(slug)
  }, [slug])

  return (
    <div className="bg-white min-h-screen">
      
      {
        loading ? (
          <div className="flex justify-center items-center py-20">
            <Loading />
          </div>
        ):(
          <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-10 md:py-16 flex flex-col md:flex-row gap-10 md:gap-16">
            {/* Main News Content */}
            <div className="flex-1 md:w-[75%] md:border-r border-gray-200 md:pr-10">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                {mainNews?.title}
              </h1>
              <p className="text-sm text-gray-500 mb-8 uppercase tracking-wide">
                {mainNews?.date}
              </p>
              
              <div
                onClick={() => setSelectedImage(`${media_url}${mainNews?.thumbnail}`)}
                className="w-full h-[300px] md:h-[500px] rounded-lg overflow-hidden mb-8 shadow-sm group cursor-pointer relative"
                style={{
                  backgroundImage: `url(${media_url}${mainNews?.thumbnail})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              >
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                  <span className="text-white opacity-0 group-hover:opacity-100 transition-all duration-300 bg-black/60 px-4 py-2 rounded-lg text-sm font-medium transform translate-y-2 group-hover:translate-y-0">
                    click to view in full
                  </span>
                </div>
              </div>

              <div className="prose prose-lg max-w-none text-gray-700 text-justify leading-relaxed mb-6">
                {parse(mainNews?.details || "")}
              </div>

              {/* Social Sharing Section */}
              <div className="border-y border-gray-100 py-6 mb-10">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                  <span className="text-gray-900 font-bold text-lg">Share this post:</span>
                  <div className="flex items-center gap-3">
                    {/* WhatsApp Share */}
                    <button
                      onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(mainNews?.title + " " + window.location.href)}`, '_blank')}
                      className="w-10 h-10 flex items-center justify-center bg-[#25D366] text-white rounded-full hover:scale-110 transition-transform shadow-sm"
                      title="Share on WhatsApp"
                    >
                      <BsWhatsapp size={20} />
                    </button>
                    {/* Facebook Share */}
                    <button
                      onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`, '_blank')}
                      className="w-10 h-10 flex items-center justify-center bg-[#1877F2] text-white rounded-full hover:scale-110 transition-transform shadow-sm"
                      title="Share on Facebook"
                    >
                      <FaFacebookF size={18} />
                    </button>
                    {/* Copy Link */}
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(window.location.href);
                        toast.success("Link copied to clipboard!");
                      }}
                      className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-600 rounded-full hover:bg-gray-200 hover:scale-110 transition-all shadow-sm"
                      title="Copy Link"
                    >
                      <FiLink size={20} />
                    </button>
                  </div>
                </div>
              </div>

              {/* Gallery Section */}
              {mainNews?.images?.length > 0 && (
                <div className="mt-12">
                   <div className="flex items-center gap-4 mb-4">
                    <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                    <p className="text-[#ed3137] font-bold uppercase tracking-widest text-xs">Event Gallery</p>
                  </div>
                  <h2 className="text-2xl font-extrabold text-[#021d53] mb-8">Capturing the Moments</h2>
                  
                  <div className="columns-2 md:columns-3 gap-3">
                    {mainNews?.images?.map((image, index) => (
                      <div 
                        key={index} 
                        onClick={() => setSelectedImage(`${media_url}${image?.image}`)}
                        className="break-inside-avoid mb-3 relative group overflow-hidden rounded-xl shadow-sm transition-all duration-300 hover:shadow-md cursor-pointer"
                      >
                        <img 
                          src={`${media_url}${image?.image}`} 
                          alt="" 
                          loading="lazy" 
                          className="w-full object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                          <span className="text-white opacity-0 group-hover:opacity-100 transition-all duration-300 bg-black/60 px-3 py-1.5 rounded-md text-xs font-medium transform translate-y-2 group-hover:translate-y-0 text-center">
                            click to view
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Sidebar - Recent Posts */}
            <div className="w-full md:w-[25%] lg:w-[20%]">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-[#021D53]">
                Recent Posts
              </h2>
              <ul className="space-y-4">
                {news.map((newsItem, index) => (
                  <li key={index} className="group transition-all duration-300">
                    <button
                      onClick={() => getNewsItem(newsItem.slug)}
                      className="text-left w-full text-gray-600 group-hover:text-[#021D53] text-sm font-medium leading-snug transition-colors"
                    >
                      <Link 
                        to={`/news-events/news/${newsItem.slug}`}
                        className="block py-1 border-l-2 border-transparent group-hover:border-[#021D53] pl-3"
                      >
                        {newsItem.title}
                      </Link>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )
      }

      {/* Lightbox Modal Overlay */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-[9999] bg-black/80 backdrop-blur-[2px] flex items-center justify-center p-4 transition-all duration-300 animate-in fade-in"
          onClick={() => setSelectedImage(null)}
        >
          {/* Modal Container */}
          <div 
            className="relative bg-white p-2 md:p-3 rounded-xl shadow-2xl max-w-5xl w-full flex flex-col items-center animate-in zoom-in-95 duration-300 sm:m-4"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header/Close Bar */}
            <div className="absolute -top-12 right-0 flex justify-end w-full">
              <button 
                className="text-white hover:text-gray-300 transition-colors p-2 bg-black/20 rounded-full hover:bg-black/40 flex items-center gap-2"
                onClick={() => setSelectedImage(null)}
              >
                <span className="text-sm font-medium hidden md:block">Close</span>
                <IoClose size={28} />
              </button>
            </div>
            
            {/* Image Wrapper */}
            <div className="w-full overflow-hidden rounded-lg flex items-center justify-center bg-gray-100">
              <img 
                src={selectedImage} 
                alt="Fullscreen" 
                className="max-w-full max-h-[80vh] object-contain select-none shadow-inner"
              />
            </div>
          </div>
        </div>
      )}
      
      <Footer />
    </div>
  );
};

export default NewsItem;
